const modals = {
  technologies: {
    icons: [
      "html",
      "css",
      "javascript",
      "sass",
      "react",
      "vue",
      "git gitLight",
      "tailwind tailwindLight",
      "storybook storybookLight",
      "storyblok storyblokLight",
    ],
    articles: [
      {
        title: "Front-End Development:",
        points: [
          {
            bolding: "HTML, CSS, JavaScript:",
            text: "These foundational languages enable me to craft engaging and interactive user interfaces.",
          },
          {
            bolding: "Sass:",
            text: "Leveraging the power of Sass enhances my CSS workflow, enabling more efficient styling and maintainable code.",
          },
          {
            bolding: "React and Vue:",
            text: "Proficiency in both React and Vue equips me to build dynamic and responsive front-end applications, catering to diverse project requirements.",
          },
        ],
      },
      {
        title: "Version Control and Collaboration:",
        points: [
          {
            bolding: "Git:",
            text: "My expertise in Git ensures seamless version control and facilitates collaborative development.",
          },
        ],
      },
      {
        title: "Design and Styling:",
        points: [
          {
            bolding: "Tailwind CSS:",
            text: "I am skilled in utilizing Tailwind CSS to expedite the styling process, resulting in streamlined and visually appealing designs.",
          },
        ],
      },
      {
        title: "Documentation and Component Management:",
        points: [
          {
            bolding: "Storybook:",
            text: "Utilizing Storybook, I create a structured library of components, simplifying development, testing, and maintenance.",
          },
        ],
      },
      {
        title: "Content Management:",
        points: [
          {
            bolding: "Storyblok:",
            text: "My proficiency in Storyblok enables efficient content management, enhancing the agility of projects that involve dynamic content updates.",
          },
        ],
      },
    ],
  },
};

export { modals };
